// @ts-strict-ignore
import dayjs from 'dayjs'
import type { DocumentContext } from 'next/document'

import { filtersFromQuery } from '~/utils/filters'
import { globalBoostrapPropsWrapper, globalBootstrap, GlobalBootstrapWrapper } from '~/utils/globalBootstrap'

import RestaurantListingPage, { getRestaurantListQueryVariables } from '~/components/Listing/pages/RestaurantListingPage'
import { PAGE_SIZE } from '~/components/Listing/pages/RestaurantListingPage/RestaurantListingPageUtils'
import { getClubConfig, redirectIfFeatureDisabledInConfig } from '~/config/clubConfig'
import { defaultSearchSettings, paths } from '~/constants'
import {
  AllTagsDocument,
  OngoingFestivalsListDocument,
  RestaurantsListDocument,
  SelectedRegionDocument,
  SelectedRegionQuery,
} from '~/generated/graphql'
import Layout from '~/layout'

export const getServerSideProps = async (ctx: DocumentContext) => {
  const { apolloClient } = await globalBootstrap({ ctx })

  const clubConfig = getClubConfig()
  if (!clubConfig.d2dEnabled) {
    return redirectIfFeatureDisabledInConfig
  }

  const currentDate = dayjs()
  const { selectedRegion } = apolloClient.cache.readQuery<SelectedRegionQuery>({
    query: SelectedRegionDocument,
  })

  const variables = getRestaurantListQueryVariables({
    selectedRegion,
    filters: filtersFromQuery(ctx.query),
    search: defaultSearchSettings({ untypedQuery: ctx.query }),
    startsOn: currentDate,
    endsOn: currentDate.clone().add(30, 'day'),
    first: PAGE_SIZE,
  })

  const [
    { data },
    {
      data: { tags },
    },
  ] = await Promise.all([
    apolloClient.query({
      query: RestaurantsListDocument,
      variables,
    }),
    apolloClient.query({ query: AllTagsDocument, variables: { regionId: selectedRegion.id } }),
    apolloClient.query({ query: OngoingFestivalsListDocument }),
  ])

  return globalBoostrapPropsWrapper(
    { apolloClient },
    {
      props: {
        data,
        tags,
        availableDatesISOString: null,
        minDateISOString: currentDate.toISOString(),
      },
    }
  )
}

const WrappedPage = GlobalBootstrapWrapper(RestaurantListingPage)

WrappedPage.getLayout = function (page) {
  return (
    <Layout metadata={{ canonical: paths.restaurants }} renderFestivalTabs>
      {page}
    </Layout>
  )
}

export default WrappedPage
